import axios, {AxiosResponse} from 'axios';
import { LOCAL_STORAGE_KEYS } from 'common/constants/localStorageKeys';
import { isMobile, redirectToLogin } from 'helpers';
import {handleApiException} from "../helpers/apiResponseHelper";

const baseUrl = process.env.REACT_APP_API_URL;
const apiVersion = process.env.REACT_APP_API_VERSION;

function getApiUrl() {
    return baseUrl + '/v' + apiVersion;
}
function getBaseUrl() {
    return baseUrl;
}


async function loginWithSmartId(code: string): Promise<string> {
    return new Promise((resolve, reject) => {
        postSmartIdLogin(code).then(
            response => {
                resolve(response.data.data)
            }
        ).catch(error => {
            if (error.response) {
                reject(error.response.status)
            } else {
                reject(500)
            }
        });
    });
}

async function loginWithMobileId(code: string, phoneNumber: string): Promise<string> {
    return new Promise((resolve, reject) => {
        postMobileIdLogin(code, phoneNumber).then(
            response => {
                resolve(response.data.data)
            }
        ).catch(error => {
            if (error.response) {
                reject(error.response.status)
            } else {
                reject(500)
            }
        });
    });
}

async function pollSmartOrMobileIdLogin(personalIdentityCode: string, verificationCode: string, type: 'smart-id' | 'mobile-id'): Promise<string> {
    return new Promise((resolve, reject) => {
        postSmartOrMobileIdLoginPoll(personalIdentityCode, verificationCode, type).then(
            response => {
                resolve(response.data.data)
            }
        ).catch(error => {
            if (error.response) {
                reject(error.response.status)
            } else {
                reject(500)
            }
        });
    });
}

function postSmartIdLogin(personalIdentityCode: string): Promise<AxiosResponse> {
    return axios.post(
        baseUrl + "/v1/auth/smart-id/login", {
            personalIdentityCode
        },
        {
            headers: {
                "content-type": "application/json",
                "x-with-app": isMobile()
            },
        });
}

function postMobileIdLogin(personalIdentityCode: string, phoneNumber: string): Promise<AxiosResponse> {
    return axios.post(
        baseUrl + "/v1/auth/mobile-id/login", {
            personalIdentityCode,
            phoneNumber
        },
        {
            headers: {
                "content-type": "application/json",
                "x-with-app": isMobile()
            },
        });
}

function postSmartOrMobileIdLoginPoll(personalIdentityCode: string, verificationCode: string, type: 'smart-id' | 'mobile-id'): Promise<AxiosResponse> {
    return axios.post(
        baseUrl + "/v1/auth/" + type + "/poll", {
            "personalIdentityCode": personalIdentityCode,
            "verificationCode": verificationCode
        },
        {
            withCredentials: true,
            headers: {
                "content-type": "application/json",
            },
        });
}

function exchangeToken(redirectToken: string): Promise<AxiosResponse> {
    return axios.post(
        baseUrl + "/v1/auth/exchange-token", redirectToken,
        {
            withCredentials: true,
            headers: {
                "content-type": "application/json",
                "x-with-app": isMobile(),
            },
        });
}

function refresh(){
    return axios.post(
        `${baseUrl}/v1/auth/refresh`,
        {},
        {
          withCredentials: true,
          headers: {
            "x-with-app": isMobile(),
            "content-type": "application/json",
          },
        }
      )
        .catch(handleApiException);
}

async function logoutAxios(){
    return axios.post(
        `${baseUrl}/v1/auth/logout`,
        {},
        {
          withCredentials: true,
        }
      );
}

function logout() {
    logoutAxios()
        .then(() => {
            clearLocalStorage();

            if (window.location.href.indexOf('login') === -1 && window.location.href.indexOf('redirect') === -1) {
                redirectToLogin();
            }
        });
}

function clearLocalStorage() {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTHORIZATION_HEADER);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_ID);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.USER);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID);
}

const AuthenticationService = {
    getApiUrl,
    getBaseUrl,
    loginWithSmartId,
    loginWithMobileId,
    pollSmartOrMobileIdLogin,
    logout,
    refresh,
    exchangeToken
}

export default AuthenticationService;

export const POLL_MAX_RETRY_COUNT_ON_FAILED_REQUEST = 3;
